import { create } from 'zustand';

interface UIState {
  // Sidebar state
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;

  // Theme
  darkMode: boolean;

  // Loading states
  globalLoading: boolean;

  // Modal states
  activeModal: string | null;
  modalData: unknown;

  // Actions
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleDarkMode: () => void;
  setGlobalLoading: (loading: boolean) => void;
  openModal: (modalId: string, data?: unknown) => void;
  closeModal: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  // Initial state
  sidebarOpen: true,
  sidebarCollapsed: false,
  darkMode: false,
  globalLoading: false,
  activeModal: null,
  modalData: null,

  // Actions
  toggleSidebar: () =>
    set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

  toggleDarkMode: () =>
    set((state) => ({ darkMode: !state.darkMode })),

  setGlobalLoading: (loading) => set({ globalLoading: loading }),

  openModal: (modalId, data) =>
    set({ activeModal: modalId, modalData: data }),

  closeModal: () => set({ activeModal: null, modalData: null }),
}));

// Modal IDs
export const MODALS = {
  CREATE_TICKET: 'create-ticket',
  CREATE_CUSTOMER: 'create-customer',
  ADD_NOTE: 'add-note',
  ADD_PART: 'add-part',
  CONFIRM_DELETE: 'confirm-delete',
  AI_DIAGNOSIS: 'ai-diagnosis',
  PAYMENT: 'payment',
} as const;
